export default function getIsSplunkLoggingEnabled() {
  const chanceToEnableLogging = window.VISA_GLOBALS.splunkLoggingProbabilityValue;
  const threshold = Math.floor(Math.random() * 100) + 1;
  if (threshold > chanceToEnableLogging) {
    return false;
  }
  return true;
}
